import * as types from "../constants/ActionTypes";
var initialState = {};

var dataSettings = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_DATA_SETTINGS:
      state = action.dataSettings;
      return { ...state };
    default:
      return { ...state };
  }
};
export default dataSettings;
